import styles from "./skills.module.scss";

const Skills = () => {
  const skills = [
    { id: 0, title: "Software Engineering", p: "60%" },
    { id: 1, title: "Software Development", p: "70%" },
    { id: 2, title: "Machine Learning", p: "30%" },
    { id: 3, title: "Deep Learning", p: "25%" },
    { id: 4, title: "Computer Vision", p: "25%" },
    { id: 5, title: "NLP", p: "15%" },
    { id: 6, title: "C", p: "50%" },
    { id: 7, title: "C++", p: "40%" },
    { id: 8, title: "Python", p: "70%" },
    { id: 9, title: "Javascript", p: "80%" },
    { id: 10, title: "Web Development", p: "70%" },
  ];

  const skill_list = skills.map((skill) => {
    return (
      <div key={skill.id} className={`${styles.skill} w-1/2 md:w-1/2 xl:w-1/4`}>
        <div className={styles.title}>
          <span>{skill.title}</span>
          <span>{skill.p}</span>
        </div>
        <div className={styles.bar}>
          <span style={{ width: skill.p }}></span>
        </div>
      </div>
    );
  });

  return (
    <div className={styles.main} id="skills">
      {/* Start Skills */}
      {skill_list}
      {/* End Skills */}
    </div>
  );
};

export default Skills;
